"use client"

import {
  BookClosed,
  BookOpen01,
  Codepen,
  FileCode01,
  LifeBuoy01,
  PlayCircle,
  Stars02,
} from "@untitledui/icons"
import type { FC, ReactNode } from "react"

import { NavMenuItemLink } from "./base-components/nav-menu-item"

import { Button } from "@uui/base/buttons/button"

interface MenuItem {
  title: string
  subtitle?: string
  href: string
  Icon: FC<{ className?: string }>
  badge?: ReactNode
}

interface MenuColumn {
  title: string
  items: MenuItem[]
}

const columns: MenuColumn[] = [
  // collapse-start
  {
    title: "Resources",
    items: [
      {
        title: "Blogs",
        subtitle:
          "The latest industry new and guides curated by our expert team.",
        href: "/",
        Icon: BookClosed,
      },
      {
        title: "Customer stories",
        subtitle:
          "Learn how our customers are using Untitled UI to 10x their growth.",
        href: "/",
        Icon: Stars02,
      },
      {
        title: "Video tutorials",
        subtitle:
          "Get up and running on our newest features and in-depth guides.",
        href: "/",
        Icon: PlayCircle,
      },
    ],
  },
  {
    title: "Support",
    items: [
      {
        title: "Documentation",
        subtitle:
          "In-depth articles on our tools and technologies to empower teams.",
        href: "/",
        Icon: FileCode01,
      },
      {
        title: "Help and support",
        subtitle:
          "Need help with something? Our expert team is here to help 24/7.",
        href: "/",
        Icon: LifeBuoy01,
      },
      {
        title: "API reference",
        subtitle: "In-depth reference doc and helpful guides for our API.",
        href: "/",
        Icon: Codepen,
      },
    ],
  },
  // collapse-end
]

export const DropdownMenuWithTwoColsAndLinksAndFooter = () => {
  return (
    <div className="px-3 pb-2 md:max-w-200 md:p-0">
      <nav className="bg-secondary ring-secondary_alt overflow-hidden rounded-xl shadow-xs ring-1 md:rounded-2xl md:shadow-lg">
        <div className="bg-primary ring-secondary flex flex-col gap-5 rounded-xl pt-4 pb-5 ring-1 md:gap-6 md:rounded-t-2xl md:p-6 md:pt-5">
          <div className="flex flex-col gap-1 px-4 md:p-0">
            <p className="text-md text-primary font-semibold">Resources</p>
            <p className="text-tertiary text-sm">
              Get started and learn more about our products.
            </p>
          </div>

          <div className="flex flex-col gap-5 md:flex-row md:gap-8 md:py-0">
            <div className="border-b-secondary -mb-px flex flex-col gap-4 border-b px-4 pb-5 md:mb-0 md:gap-5 md:border-none md:p-0">
              <h3 className="text-brand-tertiary text-sm font-semibold">
                Get started
              </h3>
              <ul className="flex flex-col gap-3">
                {[
                  { title: "Setup 101", href: "#" },
                  { title: "Adding users", href: "#" },
                  { title: "Video tutorials", href: "#" },
                  { title: "Libraries and SDKs", href: "#" },
                  { title: "Adding plugins", href: "#" },
                  { title: "Dashboard templates", href: "#" },
                ].map((item) => (
                  <li key={item.title}>
                    <Button href={item.href} color="link-gray" size="lg">
                      {item.title}
                    </Button>
                  </li>
                ))}
              </ul>
            </div>

            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-2">
              {columns.map((column) => (
                <div key={column.title}>
                  <h3 className="text-brand-tertiary mb-2 px-4 text-sm font-semibold md:px-0">
                    {column.title}
                  </h3>
                  <ul className="flex flex-col gap-0.5">
                    {column.items.map(({ title, subtitle, href, Icon }) => (
                      <li key={title}>
                        <NavMenuItemLink
                          icon={Icon}
                          title={title}
                          subtitle={subtitle}
                          href={href}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="max-w-container mx-auto flex flex-col px-4 py-5 md:flex-row md:items-center md:justify-between md:px-6">
          <Button
            href="#"
            color="secondary"
            size="md"
            iconLeading={BookOpen01}
            className="hidden md:flex"
          >
            Documentation
          </Button>
          <Button href="#" color="primary" size="md" className="hidden md:flex">
            View all resources
          </Button>
          <Button href="#" color="primary" size="sm" className="md:hidden">
            View all resources
          </Button>
        </div>
      </nav>
    </div>
  )
}
